import ajax from '@/modules/ajax';
import consumer from '@/modules/channels/consumer';

export default class Chat {
  constructor() {
    this.channelName = 'ChatChannel';
    this.container = $('[data-chat-container]');
    this.form = $('[data-chat-form]');
    this.recipientIdField = $('[data-recipient-id-field]');
    this.recipientNameField = $('[data-recipient-name-field]');
    this.usersWrapper = $('[data-users]');
    this.welcome = $('.chat__welcome');

    this.field = this.form.find('textarea');
  }

  bind() {
    var that = this;

    this.form.on('submit', this.onSubmit.bind(this));

    this.usersWrapper.on('click', 'a', function () {
      that.onSelectUser(this.getAttribute('data-user-id'), this.getAttribute('data-user-name'));
    });
  }

  clearForm() {
    this.field.val('')[0].focus();
  }

  connected() {
    console.log('[chat#connected]');
  }

  disconnected() {
    console.log('[chat#disconnected]');
  }

  getBox(id) {
    var box = $('[data-box-id="' + id + '"]');

    if (box.length) {
      return box;
    }

    return $('<div />', { 'class': 'chat__messages', 'data-box-id': id }).appendTo(this.container);
  }

  getUser(id, name) {
    var user = $('[data-user-id="' + id + '"]');

    if (user.length) {
      return user;
    }

    var link = $('<a />', {
      'class': 'chat__user',
      'data-user-id': id,
      'data-user-name': id,
      'href': 'javascript:void(0);',
      'text': name,
    });

    var li = $('<li />').append(link).prependTo(this.usersWrapper);

    return link;
  }

  highLight(user) {
    this.usersWrapper.find('[data-user-id]').removeClass('chat__user--active');

    user.addClass('chat__user--active');
  }

  init() {
    this.bind();

    this.Chat = consumer.subscriptions.create(this.subscriptionOptions(), {
      connected: this.connected,
      disconnected: this.disconnected,
      received: this.received.bind(this),
      send_message: this.sendMessage,
    });

    if (/\?idy/.test(window.location.href)) {
      this.onSelectUser(this.recipientIdField.val(), this.recipientNameField.val());
    }
  }

  isBoxLoaded(box) {
    return box.hasClass('chat__messages--loaded');
  }

  loadMessages(id) {
    var box = this.getBox(id);
    var that = this;

    if (this.isBoxLoaded(box)) {
      this.showBox(box);
      this.scrollBox(box);
    } else {
      ajax({
        done: (json) => {
          box.empty().addClass('chat__messages--loaded');

          that.welcome.remove();
          that.showBox(box);

          if (json.length) {
            that.writeMessages(json, box);
            that.scrollBox(box);
          }
        },
        url: `/api/chats/${id}`,
      });
    }
  }

  loadUser(id, callback) {
    ajax({ done: callback, url: `/api/users/${id}` });
  }

  message(json) {
    var message = $('<div />', { class: 'chat__message chat__message--' + json.kind });
    var body = $('<div />', { class: 'chat__message__body', text: json.body });
    var time = $('<div />', { class: 'chat__message__time', text: json.created_at });

    return message.append(body, time);
  }

  onSelectUser(id, name) {
    if (id) {
      var box = this.getBox(id);
      var user = this.getUser(id, name);

      this.recipientIdField.val(id);
      this.highLight(user);

      this.form.removeClass('hide');

      this.loadMessages(id);
    }
  }

  onSubmit() {
    var message = this.field.val().trim();

    if (message.length) {
      this.Chat.send_message(message, this.recipientIdField.val());
    }

    this.clearForm();

    return false;
  }

  received(json) {
    console.log('[chat#received] ' + JSON.stringify(json));

    if (!json) {
      return;
    }

    var box = this.getBox(json['target_id']);

    if (this.isBoxLoaded(box)) {
      this.writeMessage(json, box);

      this.showBox(box);
      this.scrollBox(box);
    }

    if (json['kind'] == 'received') {
      var that = this;

      this.loadUser(json['sender_id'], function (data) {
        that.getUser(data['id'], data['name']);
      });
    }
  }

  scrollBox(box) {
    box.scrollTop(box[0].scrollHeight);
  }

  sendMessage(message, recipientId) {
    console.log('[chat#sendMessage] to "' + recipientId + '": ' + JSON.stringify(message));

    this.perform('send_message', { message: message, recipientId: recipientId });
  }

  showBox(box) {
    $('[data-box-id]').hide();

    box.show();
  }

  subscriptionOptions() {
    return { channel: this.channelName, recipientId: this.recipientIdField.val() };
  }

  writeMessage(json, box) {
    box.append(this.message(json));
  }

  writeMessages(json, box) {
    this.welcome.remove();

    for (var i = 0; i < json.length; i++) {
      this.writeMessage(json[i], box);
    }
  }
}
